import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/remove-self-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const RemoveSelfModal = ({
  accountId,
  currentUserId,
  isRemoveSelfVisible,
  onHideRemoveSelf,
  onRemoveUser
}) => (
  <Modal
    isVisible={ isRemoveSelfVisible }
    onClose={ onHideRemoveSelf }
    transitionName={ "remove-self-modal" }
  >
    <h2>Are you sure?</h2>
    <div>
      Are you sure you want to remove yourself from this account?
      You will no longer be able to access this account, unless re-invited.
    </div>
    <div>You will also be logged out of Squirrel Street.</div>
    <div className={ styles["button-group"] }>
      <Button link onClick={ onHideRemoveSelf }>cancel</Button>
      <Button danger onClick={ () => onRemoveUser(accountId, currentUserId) }>Remove me from this account</Button>
    </div>
  </Modal>
);

RemoveSelfModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  currentUserId: PropTypes.string.isRequired,
  isRemoveSelfVisible: PropTypes.bool.isRequired,
  onHideRemoveSelf: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/remove-self-modal.jsx